import { render, staticRenderFns } from "./UploadMusic.vue?vue&type=template&id=4858907e"
import script from "./UploadMusic.vue?vue&type=script&lang=js"
export * from "./UploadMusic.vue?vue&type=script&lang=js"
import style0 from "./UploadMusic.vue?vue&type=style&index=0&id=4858907e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports